import React, { useEffect, useState } from 'react';
import { WrappedComponentProps, injectIntl, useIntl } from 'react-intl';
import {
    IAccountData,
    IRegisterWarrantyInput,
    RegisterWarrantyErrors,
} from '../../../models/warranty-center';
import { IAccountBillTo } from '../../../models/account';
import { IPatientDevice } from '../../../models/device';
import { INameCode } from '../../../models/pro-sites';
import TextInput from '../../inputs/text-input';
import { IAccount } from '../../../models/company-account';
import SelectInput from '../../inputs/select-input';
import DatePicker from 'react-datepicker';
import FirstConsentModal from './firstConsentModal';
import SecondConsentModal from './secondConsentModal';
interface IRegisterWarrantyProps {
    userContactName: string;
    userEmailAddress: string;
    userPhoneNumber: string;
    billToAccounts: IAccountBillTo[] | null;
    accountData: IAccountData;
    deviceData: IPatientDevice | null;
    country: string;
    validating: boolean;
    errors: RegisterWarrantyErrors;
    updateFormData: (
        serialNumber1: string,
        serialNumber2: string,
        serialNumber3: string,
        serialNumber4: string,
        serialNumber5: string,
        serialNumber6: string,
        serialNumber1ProductType: string,
        serialNumber2ProductType: string,
        serialNumber3ProductType: string,
        serialNumber4ProductType: string,
        serialNumber5ProductType: string,
        serialNumber6ProductType: string,
        aidType1: string,
        aidType2: string,
        aidType3: string,
        aidType4: string,
        aidType5: string,
        aidType6: string,
        billToAccount: string,
        shipToAccount: string,
        phoneNumber: string,
        contactName: string,
        email: string,
        patientFirstName: string,
        patientLastName: string,
        fitDate: Date | null,
        serialNUmber1Error: boolean,
        serialNUmber2Error: boolean,
        serialNUmber3Error: boolean,
        serialNUmber4Error: boolean,
        serialNUmber5Error: boolean,
        serialNUmber6Error: boolean,
        fitDateVisibility: boolean
    ) => void;
}
export const RegisterWarranty = ({
    userContactName,
    userEmailAddress,
    userPhoneNumber,
    billToAccounts,
    accountData,
    deviceData,
    country,
    validating,
    errors,
    updateFormData,
}: IRegisterWarrantyProps) => {
    const intl = useIntl();
    const [registerWarrantyInputData, setRegisterWarrantyInputData] =
        useState<IRegisterWarrantyInput>({
            contactName: userContactName,
            phoneNumber: userPhoneNumber,
            emailAddress: userEmailAddress,
        });
    const [serialNumber1, setSerialNumber1] = useState('');
    const [serialNumber2, setSerialNumber2] = useState('');
    const [serialNumber3, setSerialNumber3] = useState('');
    const [serialNumber4, setSerialNumber4] = useState('');
    const [serialNumber5, setSerialNumber5] = useState('');
    const [serialNumber6, setSerialNumber6] = useState('');
    const [serialNumber1Changed, setSerialNumber1Changed] = useState(false);
    const [serialNumber2Changed, setSerialNumber2Changed] = useState(false);
    const [serialNumber3Changed, setSerialNumber3Changed] = useState(false);
    const [serialNumber4Changed, setSerialNumber4Changed] = useState(false);
    const [serialNumber5Changed, setSerialNumber5Changed] = useState(false);
    const [serialNumber6Changed, setSerialNumber6Changed] = useState(false);
    const [serialNumberOrder, setSerialNumberOrder] = useState<number>(0);
    const [lookingUpSerialNumber1, setLookingUpSerialNumber1] = useState(false);
    const [lookingUpSerialNumber2, setLookingUpSerialNumber2] = useState(false);
    const [lookingUpSerialNumber3, setLookingUpSerialNumber3] = useState(false);
    const [lookingUpSerialNumber4, setLookingUpSerialNumber4] = useState(false);
    const [lookingUpSerialNumber5, setLookingUpSerialNumber5] = useState(false);
    const [lookingUpSerialNumber6, setLookingUpSerialNumber6] = useState(false);
    const [serialNumberError1, setSerialNumberError1] = useState(false);
    const [serialNumberError2, setSerialNumberError2] = useState(false);
    const [serialNumberError3, setSerialNumberError3] = useState(false);
    const [serialNumberError4, setSerialNumberError4] = useState(false);
    const [serialNumberError5, setSerialNumberError5] = useState(false);
    const [serialNumberError6, setSerialNumberError6] = useState(false);
    const [validSerilNUmber1, setValidSerialNumber1] = useState(true);
    const [validSerilNUmber2, setValidSerialNumber2] = useState(true);
    const [validSerilNUmber3, setValidSerialNumber3] = useState(true);
    const [validSerilNUmber4, setValidSerialNumber4] = useState(true);
    const [validSerilNUmber5, setValidSerialNumber5] = useState(true);
    const [validSerilNUmber6, setValidSerialNumber6] = useState(true);
    const [showPatientInfo, setShowPatientInfo] = useState(false);
    const [userAccountData, setUserAccountData] =
        useState<IAccountData>(accountData);
    const [billToAccount, setBillToAccount] = useState<string>('');
    const [shipToAccount, setShipToAccount] = useState<string>('');
    const [contactName, setContactName] = useState(userContactName);
    const [phoneNumber, setPhoneNumber] = useState(userPhoneNumber);
    const [email, setEmail] = useState(userEmailAddress);
    const [patientFirstName, setPatientFirstName] = useState('');
    const [patientLastName, setPatientLastName] = useState('');
    const [showFitDate, setShowFitDate] = useState(false);
    const serialNumber2Required = 'Serial Number 2 is required';
    const serialNumber3Required = 'Serial Number 3 is required';
    const serialNumber4Required = 'Serial Number 4 is required';
    const serialNumber5Required = 'Serial Number 5 is required';
    const serialNumber6Required = 'Serial Number 6 is required';
    const unspecifiedError: any =
        'An unspecified error occurred submitting shipping label Request.';
    const [isNuEar, setIsNuEar] = useState(
        window.location.href.includes('nuearpro')
    );
    const [fitDate, SetFitDate] = useState<Date | null>(null);
    const [showFirstConsentModal, SetShowFirstConsentModal] = useState(false);
    const [showSecondConsentModal, SetShowSecondConsentModal] = useState(false);
    const serialNumber1ConsentAck = () => {
        setLookingUpSerialNumber(1, true);
        callUpdateFormData();
    };
    const setFitDateVisibility = () => {
        if (country === 'CA') {
            setShowFitDate(true);
        } else if (
            registerWarrantyInputData.serialNumber1ProductType ===
                'Standard Product' ||
            registerWarrantyInputData.serialNumber2ProductType ===
                'Standard Product' ||
            registerWarrantyInputData.serialNumber3ProductType ===
                'Standard Product' ||
            registerWarrantyInputData.serialNumber4ProductType ===
                'Standard Product' ||
            registerWarrantyInputData.serialNumber5ProductType ===
                'Standard Product' ||
            registerWarrantyInputData.serialNumber6ProductType ===
                'Standard Product'
        ) {
            setShowFitDate(true);
        } else {
            setShowFitDate(false);
        }
    };
    const onFitDateChange = (
        _date: Date | null,
        event: React.SyntheticEvent<any, Event> | undefined
    ) => {
        SetFitDate(_date);
        console.log(fitDate);
    };
    useEffect(() => {
        if (fitDate) {
            callUpdateFormData();
        }
    }, [fitDate]);
    useEffect(() => {
        if (!errors) return;
    }, [errors]);
    const onPatientFirstNameChange = (event: any) => {
        const { name, value } = event.target;
        setPatientFirstName(value);
    };
    const onPatientLastNameChange = (event: any) => {
        const { name, value } = event.target;
        setPatientLastName(value);
    };
    const onBillToAccountChange = (event: any) => {
        const { name, value } = event.target;
        setBillToAccount(value);
    };
    const onShipToAccountChange = (event: any) => {
        const { name, value } = event.target;
        setShipToAccount(value);
    };
    const onSerialNumber1Change = (event: any) => {
        const { name, value } = event.target;
        setSerialNumber1(value);
        setSerialNumberOrder(1);
        setSerialNumber1Changed(true);
    };
    const onSerialNumber2Change = (event: any) => {
        const { name, value } = event.target;
        setSerialNumber2(value);
        setSerialNumberOrder(2);
        setSerialNumber2Changed(true);
    };
    const onSerialNumber3Change = (event: any) => {
        const { name, value } = event.target;
        setSerialNumber3(value);
        setSerialNumberOrder(3);
        setSerialNumber3Changed(true);
    };
    const onSerialNumber4Change = (event: any) => {
        const { name, value } = event.target;
        setSerialNumber4(value);
        setSerialNumberOrder(4);
        setSerialNumber4Changed(true);
    };
    const onSerialNumber5Change = (event: any) => {
        const { name, value } = event.target;
        setSerialNumber5(value);
        setSerialNumberOrder(5);
        setSerialNumber5Changed(true);
    };
    const onSerialNumber6Change = (event: any) => {
        const { name, value } = event.target;
        setSerialNumber6(value);
        setSerialNumberOrder(6);
        setSerialNumber6Changed(true);
    };
    const updateUserData = (event: any) => {
        switch (event.target.name) {
            case 'contactName':
                setContactName(event.target.value);
                registerWarrantyInputData.contactName = event.target.value;
                break;
            case 'phoneNumber':
                setPhoneNumber(event.target.value);
                registerWarrantyInputData.phoneNumber = event.target.value;
                break;
            case 'emailAddress':
                setEmail(event.target.value);
                registerWarrantyInputData.emailAddress = event.target.value;
                break;
        }
    };
    const isFitDateRequired = (): boolean => {
        if (
            registerWarrantyInputData.serialNumber1ProductType ===
                'Standard Product' ||
            registerWarrantyInputData.serialNumber2ProductType ===
                'Standard Product' ||
            registerWarrantyInputData.serialNumber3ProductType ===
                'Standard Product' ||
            registerWarrantyInputData.serialNumber4ProductType ===
                'Standard Product' ||
            registerWarrantyInputData.serialNumber5ProductType ===
                'Standard Product' ||
            registerWarrantyInputData.serialNumber6ProductType ===
                'Standard Product'
        ) {
            return true;
        } else {
            return false;
        }
    };
    const setSerialNumberError = (number: number, value: boolean) => {
        if (number === 1) setSerialNumberError1(value);
        if (number === 2) setSerialNumberError2(value);
        if (number === 3) setSerialNumberError3(value);
        if (number === 4) setSerialNumberError4(value);
        if (number === 5) setSerialNumberError5(value);
        if (number === 6) setSerialNumberError6(value);
    };
    const setLookingUpSerialNumber = (number: number, value: boolean) => {
        if (number === 1) setLookingUpSerialNumber1(value);
        if (number === 2) setLookingUpSerialNumber2(value);
        if (number === 3) setLookingUpSerialNumber3(value);
        if (number === 4) setLookingUpSerialNumber4(value);
        if (number === 5) setLookingUpSerialNumber5(value);
        if (number === 6) setLookingUpSerialNumber6(value);
    };
    const setValidSerialNumber = (number: number, value: boolean) => {
        if (number === 1) setValidSerialNumber1(value);
        if (number === 2) setValidSerialNumber2(value);
        if (number === 3) setValidSerialNumber3(value);
        if (number === 4) setValidSerialNumber4(value);
        if (number === 5) setValidSerialNumber5(value);
        if (number === 6) setValidSerialNumber6(value);
    };
    const setRegisterWarrantyInput = (
        number: number,
        serialNumber: string,
        productType: string,
        aidType: string,
        patientName: string
    ) => {
        if (number === 1) {
            const updatedValues = {
                serialNumber1: serialNumber,
                serialNumber1ProductType: productType,
                aidType1: aidType,
                patientName1: patientName,
            };
            setRegisterWarrantyInputData((prevState) => {
                return { ...prevState, ...updatedValues };
            });
        }
        if (number === 2) {
            const updatedValues = {
                serialNumber2: serialNumber,
                serialNumber2ProductType: productType,
                aidType2: aidType,
                patientName2: patientName,
            };
            setRegisterWarrantyInputData((prevState) => {
                return { ...prevState, ...updatedValues };
            });
        }
        if (number === 3) {
            const updatedValues = {
                serialNumber3: serialNumber,
                serialNumber3ProductType: productType,
                aidType3: aidType,
                patientName3: patientName,
            };
            setRegisterWarrantyInputData((prevState) => {
                return { ...prevState, ...updatedValues };
            });
        }
        if (number === 4) {
            const updatedValues = {
                serialNumber4: serialNumber,
                serialNumber4ProductType: productType,
                aidType4: aidType,
                patientName4: patientName,
            };
            setRegisterWarrantyInputData((prevState) => {
                return { ...prevState, ...updatedValues };
            });
        }
        if (number === 5) {
            const updatedValues = {
                serialNumber5: serialNumber,
                serialNumber5ProductType: productType,
                aidType5: aidType,
                patientName5: patientName,
            };
            setRegisterWarrantyInputData((prevState) => {
                return { ...prevState, ...updatedValues };
            });
        }
        if (number === 6) {
            const updatedValues = {
                serialNumber6: serialNumber,
                serialNumber6ProductType: productType,
                aidType6: aidType,
                patientName6: patientName,
            };
            setRegisterWarrantyInputData((prevState) => {
                return { ...prevState, ...updatedValues };
            });
        }
    };
    const clearPatientName = (number: number) => {
        setRegisterWarrantyInputData({ patientName1: '' });
    };
    useEffect(() => {
        if (deviceData !== null && deviceData !== undefined) {
            setLookingUpSerialNumber(serialNumberOrder, false);
            if (deviceData.unavailable! || deviceData.device === null) {
                setSerialNumberError(serialNumberOrder, true);
                setValidSerialNumber(serialNumberOrder, false);
            } else {
                if (
                    (country === 'US' &&
                        (deviceData.device.categoryProductType ===
                            'Standard Product' ||
                            deviceData.device.categoryProductType ===
                                'Serialized Accessory')) ||
                    (country === 'CA' &&
                        (deviceData.device.productClass === 'BTC' ||
                            deviceData.device.productClass === 'RIC'))
                ) {
                    setLookingUpSerialNumber(serialNumberOrder, false);
                    setSerialNumberError(serialNumberOrder, false);
                    setValidSerialNumber(serialNumberOrder, true);
                    setShowPatientInfo(true);
                    setFitDateVisibility();
                    setRegisterWarrantyInput(
                        serialNumberOrder,
                        deviceData.device.serialNumber,
                        deviceData.device.categoryProductType,
                        deviceData.device.hearingAidType,
                        (deviceData.patientFirstName
                            ? deviceData.patientFirstName.trim()
                            : ''
                        ).concat(
                            ' , ',
                            deviceData.patientLastName
                                ? deviceData.patientLastName.trim()
                                : ''
                        )
                    );
                } else {
                    setSerialNumberError(serialNumberOrder, true);
                    setValidSerialNumber(serialNumberOrder, false);
                }
            }
        }
        setSerialNumber1Changed(false);
        setSerialNumber2Changed(false);
        setSerialNumber3Changed(false);
        setSerialNumber4Changed(false);
        setSerialNumber5Changed(false);
        setSerialNumber6Changed(false);
    }, [deviceData]);
    const useLongFormat = (billToAccount: IAccountBillTo, country: string) => {
        const ibd: boolean =
            billToAccount.region === '10' ||
            billToAccount.region === '10SMP' ||
            (billToAccount.region !== null &&
                billToAccount.region.startsWith('IBD')) ||
            (billToAccount.customerCategory !== null &&
                billToAccount.customerCategory.startsWith('IBD'));
        const showCustomerCategory: boolean = country === 'US' && !ibd;
        return showCustomerCategory && billToAccount.customerCategory;
    };

    const billToListData = (accounts: IAccountBillTo[], country: string) => {
        const list: INameCode[] = [];
        for (const billToAccount of accounts) {
            let nameValue =
                billToAccount.fullAccountNumber +
                ' : ' +
                billToAccount.partyName;
            // eslint-disable-next-line react-hooks/rules-of-hooks
            if (useLongFormat(billToAccount, country)) {
                nameValue = nameValue + ' - ' + billToAccount.customerCategory;
            }

            list.push({
                name: nameValue,
                code: billToAccount.accountNumber,
            });
        }
        return list;
    };
    const shipToListData = (accounts: IAccount[]) => {
        const list: INameCode[] = [];
        for (const shipToAccount of accounts) {
            list.push({
                name:
                    shipToAccount.fullAccountNumber +
                    ' : ' +
                    shipToAccount.partyName +
                    ' , ' +
                    shipToAccount.street1,
                code: shipToAccount.accountNumber,
            });
        }
        return list;
    };
    const callUpdateFormData = () => {
        updateFormData(
            serialNumber1,
            serialNumber2,
            serialNumber3,
            serialNumber4,
            serialNumber5,
            serialNumber6,
            registerWarrantyInputData.serialNumber1ProductType!,
            registerWarrantyInputData.serialNumber2ProductType!,
            registerWarrantyInputData.serialNumber3ProductType!,
            registerWarrantyInputData.serialNumber4ProductType!,
            registerWarrantyInputData.serialNumber5ProductType!,
            registerWarrantyInputData.serialNumber6ProductType!,
            registerWarrantyInputData.aidType1!,
            registerWarrantyInputData.aidType2!,
            registerWarrantyInputData.aidType3!,
            registerWarrantyInputData.aidType4!,
            registerWarrantyInputData.aidType5!,
            registerWarrantyInputData.aidType6!,
            billToAccount,
            shipToAccount,
            phoneNumber,
            contactName,
            email,
            patientFirstName,
            patientLastName,
            fitDate,
            serialNumberError1,
            serialNumberError2,
            serialNumberError3,
            serialNumberError4,
            serialNumberError5,
            serialNumberError6,
            showPatientInfo
        );
    };

    useEffect(() => {
        if (billToAccounts !== null && billToAccounts !== undefined) {
            setUserAccountData({
                billToAccountsList: billToListData(billToAccounts, country),
                billToPartyName: billToAccounts[0].partyName,
                billToStreet1: billToAccounts[0].street1,
                billToCity: billToAccounts[0].city,
                billtoState: billToAccounts[0].state,
                billToPostalCode: billToAccounts[0].postalCode,
                shipToAccountsList: shipToListData(
                    billToAccounts[0].shipToAccounts
                ),
                shipToPartyName: billToAccounts[0].shipToAccounts[0].partyName,
                shipToStreet1: billToAccounts[0].shipToAccounts[0].street1,
                shipToCity: billToAccounts[0].shipToAccounts[0].city,
                shipToState: billToAccounts[0].shipToAccounts[0].state,
                shipToPostalCode:
                    billToAccounts[0].shipToAccounts[0].postalCode,
                contactName: userContactName,
                emailAddress: userEmailAddress,
                phoneNumber: userPhoneNumber,
            });
            setBillToAccount(billToAccounts[0].fullAccountNumber);
            setShipToAccount(
                billToAccounts[0].shipToAccounts[0].fullAccountNumber
            );
        }
    }, [billToAccounts]);

    useEffect(() => {
        const billTo = billToAccounts!.find(
            (b) => b.fullAccountNumber === billToAccount
        );
        if (billTo !== null) {
            const updatedValues = {
                billToPartyName: billTo!.partyName,
                billToStreet1: billTo!.street1,
                billToCity: billTo!.city,
                billtoState: billTo!.state,
                billToPostalCode: billTo!.postalCode,
                shipToAccountsList: shipToListData(billTo!.shipToAccounts),
                shipToPartyName: billTo!.shipToAccounts[0].partyName,
                shipToStreet1: billTo!.shipToAccounts[0].street1,
                shipToCity: billTo!.shipToAccounts[0].city,
                shipToState: billTo!.shipToAccounts[0].state,
                shipToPostalCode: billTo!.shipToAccounts[0].postalCode,
            };
            setUserAccountData((prevState) => {
                return { ...prevState, ...updatedValues };
            });
        }
    }, [billToAccount]);

    useEffect(() => {
        const billTo = billToAccounts!.find(
            (b) => b.fullAccountNumber === billToAccount
        );
        if (billTo !== null) {
            const shipTo = billTo!.shipToAccounts!.find(
                (s) => s.accountNumber === shipToAccount
            );
            const updatedValues = {
                shipToPartyName: shipTo!.partyName,
                shipToStreet1: shipTo!.street1,
                shipToCity: shipTo!.city,
                shipToState: shipTo!.state,
                shipToPostalCode: shipTo!.postalCode,
            };
            setUserAccountData((prevState) => {
                return { ...prevState, ...updatedValues };
            });
        }
    }, [shipToAccount]);

    const onAcceptFirstConsentModal = () => {
        SetShowFirstConsentModal(false);
        setLookingUpSerialNumber(1, true);
        callUpdateFormData();
    };

    const onCloseFirstConsentModal = () => {
        SetShowFirstConsentModal(false);
        SetShowSecondConsentModal(true);
    };

    const onCloseSecondConsentModal = () => {
        SetShowSecondConsentModal(false);
    };

    return (
        <div>
            <h3 className={isNuEar ? 'nuEar gutter-top' : 'starkey gutter-top'}>
                {intl.formatMessage({
                    id: 'Register_a_Standard_Product',
                    defaultMessage: ' Register a Standard Product',
                })}
            </h3>
            <div className="form-horizontal">
                <div className="form-group">
                    <TextInput
                        name="serialNumber1"
                        label="SERIAL NUMBER 1 UPPER"
                        labelClassName="control-label col-sm-4"
                        fieldClassName="col-sm-8 col-md-6"
                        value={serialNumber1}
                        maxLength={30}
                        onChange={onSerialNumber1Change}
                        onBlur={() => {
                            if (serialNumber1 && serialNumber1Changed) {
                                // setLookingUpSerialNumber(1, true);
                                // callUpdateFormData();
                                SetShowFirstConsentModal(true);
                            }
                        }}
                        required={true}
                        error={errors.serialNumber1}
                        showError={true}
                    />

                    {lookingUpSerialNumber1 && (
                        <div className="col-sm-8 control-label">
                            <img src="/images/icons/loading.gif" />
                            <span>
                                {intl.formatMessage({
                                    id: 'Looking_up_serial_number',
                                    defaultMessage: 'Looking up serial number',
                                })}
                                ...
                            </span>
                        </div>
                    )}
                    {!lookingUpSerialNumber1 && serialNumberError1 && (
                        <div className="col-sm-8 control-label text-danger">
                            {intl.formatMessage({
                                id: 'Invalid_serial_number',
                                defaultMessage: 'Invalid serial number',
                            })}
                        </div>
                    )}

                    <div className="col-sm-8 control-label alignLeft">
                        {registerWarrantyInputData.patientName1}
                    </div>
                </div>
                <div className="form-group">
                    <TextInput
                        name="serialNumber2"
                        label="SERIAL NUMBER 2 UPPER"
                        labelClassName="control-label col-sm-4"
                        fieldClassName="col-sm-8 col-md-6"
                        value={serialNumber2}
                        maxLength={30}
                        onChange={onSerialNumber2Change}
                        onBlur={() => {
                            if (serialNumber2 && serialNumber2Changed) {
                                setLookingUpSerialNumber(2, true);
                                callUpdateFormData();
                            } else if (!serialNumber2) {
                                setSerialNumberError2(false);
                            }
                        }}
                        required={false}
                        error={
                            serialNumberError2
                                ? serialNumber2Required
                                : undefined
                        }
                    />

                    {lookingUpSerialNumber2 && (
                        <div className="col-sm-8 control-label">
                            <img src="/images/icons/loading.gif" />
                            <span>
                                {intl.formatMessage({
                                    id: 'Looking_up_serial_number',
                                    defaultMessage: 'Looking up serial number',
                                })}
                                ...
                            </span>
                        </div>
                    )}
                    {!lookingUpSerialNumber2 && serialNumberError2 && (
                        <div className="col-sm-8 control-label text-danger">
                            {intl.formatMessage({
                                id: 'Invalid_serial_number',
                                defaultMessage: 'Invalid serial number',
                            })}
                        </div>
                    )}

                    <div className="col-sm-8 control-label alignLeft">
                        {registerWarrantyInputData.patientName2}
                    </div>
                </div>
                <div className="form-group">
                    <TextInput
                        name="serialNumber3"
                        label="SERIAL NUMBER 3"
                        labelClassName="control-label col-sm-4"
                        fieldClassName="col-sm-8 col-md-6"
                        value={serialNumber3}
                        maxLength={30}
                        onChange={onSerialNumber3Change}
                        onBlur={() => {
                            if (serialNumber3 && serialNumber3Changed) {
                                setLookingUpSerialNumber(3, true);
                                callUpdateFormData();
                            } else if (!serialNumber3) {
                                setSerialNumberError3(false);
                            }
                        }}
                        required={false}
                        error={
                            serialNumberError3
                                ? serialNumber3Required
                                : undefined
                        }
                    />

                    {lookingUpSerialNumber3 && (
                        <div className="col-sm-8 control-label">
                            <img src="/images/icons/loading.gif" />
                            <span>
                                {intl.formatMessage({
                                    id: 'Looking_up_serial_number',
                                    defaultMessage: 'Looking up serial number',
                                })}
                                ...
                            </span>
                        </div>
                    )}
                    {!lookingUpSerialNumber3 && serialNumberError3 && (
                        <div className="col-sm-8 control-label text-danger">
                            {intl.formatMessage({
                                id: 'Invalid_serial_number',
                                defaultMessage: 'Invalid serial number',
                            })}
                        </div>
                    )}

                    <div className="col-sm-8 control-label alignLeft">
                        {registerWarrantyInputData.patientName3}
                    </div>
                </div>
                <div className="form-group">
                    <TextInput
                        name="serialNumber4"
                        label="SERIAL NUMBER 4"
                        labelClassName="control-label col-sm-4"
                        fieldClassName="col-sm-8 col-md-6"
                        value={serialNumber4}
                        maxLength={30}
                        onChange={onSerialNumber4Change}
                        onBlur={() => {
                            if (serialNumber4 && serialNumber4Changed) {
                                setLookingUpSerialNumber(4, true);
                                callUpdateFormData();
                            } else if (!serialNumber4) {
                                setSerialNumberError4(false);
                            }
                        }}
                        required={false}
                        error={
                            serialNumberError4
                                ? serialNumber4Required
                                : undefined
                        }
                    />

                    {lookingUpSerialNumber4 && (
                        <div className="col-sm-8 control-label">
                            <img src="/images/icons/loading.gif" />
                            <span>
                                {intl.formatMessage({
                                    id: 'Looking_up_serial_number',
                                    defaultMessage: 'Looking up serial number',
                                })}
                                ...
                            </span>
                        </div>
                    )}
                    {!lookingUpSerialNumber4 && serialNumberError4 && (
                        <div className="col-sm-8 control-label text-danger">
                            {intl.formatMessage({
                                id: 'Invalid_serial_number',
                                defaultMessage: 'Invalid serial number',
                            })}
                        </div>
                    )}

                    <div className="col-sm-8 control-label alignLeft">
                        {registerWarrantyInputData.patientName4}
                    </div>
                </div>
                <div className="form-group">
                    <TextInput
                        name="serialNumber5"
                        label="SERIAL NUMBER 5"
                        labelClassName="control-label col-sm-4"
                        fieldClassName="col-sm-8 col-md-6"
                        value={serialNumber5}
                        maxLength={30}
                        onChange={onSerialNumber5Change}
                        onBlur={() => {
                            if (serialNumber5 && serialNumber5Changed) {
                                setLookingUpSerialNumber(5, true);
                                callUpdateFormData();
                            } else if (!serialNumber5) {
                                setSerialNumberError5(false);
                            }
                        }}
                        required={false}
                        error={
                            serialNumberError5
                                ? serialNumber5Required
                                : undefined
                        }
                    />

                    {lookingUpSerialNumber5 && (
                        <div className="col-sm-8 control-label">
                            <img src="/images/icons/loading.gif" />
                            <span>
                                {intl.formatMessage({
                                    id: 'Looking_up_serial_number',
                                    defaultMessage: 'Looking up serial number',
                                })}
                                ...
                            </span>
                        </div>
                    )}
                    {!lookingUpSerialNumber5 && serialNumberError5 && (
                        <div className="col-sm-8 control-label text-danger">
                            {intl.formatMessage({
                                id: 'Invalid_serial_number',
                                defaultMessage: 'Invalid serial number',
                            })}
                        </div>
                    )}

                    <div className="col-sm-8 control-label alignLeft">
                        {registerWarrantyInputData.patientName5}
                    </div>
                </div>
                <div className="form-group">
                    <TextInput
                        name="serialNumber6"
                        label="SERIAL NUMBER 6"
                        labelClassName="control-label col-sm-4"
                        fieldClassName="col-sm-8 col-md-6"
                        value={serialNumber6}
                        maxLength={30}
                        onChange={onSerialNumber6Change}
                        onBlur={() => {
                            if (serialNumber6 && serialNumber6Changed) {
                                setLookingUpSerialNumber(6, true);
                                callUpdateFormData();
                            } else if (!serialNumber6) {
                                setSerialNumberError6(false);
                            }
                        }}
                        required={false}
                        error={
                            serialNumberError6
                                ? serialNumber6Required
                                : undefined
                        }
                    />

                    {lookingUpSerialNumber6 && (
                        <div className="col-sm-8 control-label">
                            <img src="/images/icons/loading.gif" />
                            <span>
                                {intl.formatMessage({
                                    id: 'Looking_up_serial_number',
                                    defaultMessage: 'Looking up serial number',
                                })}
                                ...
                            </span>
                        </div>
                    )}
                    {!lookingUpSerialNumber6 && serialNumberError6 && (
                        <div className="col-sm-8 control-label text-danger">
                            {intl.formatMessage({
                                id: 'Invalid_serial_number',
                                defaultMessage: 'Invalid serial number',
                            })}
                        </div>
                    )}

                    <div className="col-sm-8 control-label alignLeft">
                        {registerWarrantyInputData.patientName6}
                    </div>
                </div>
                {showPatientInfo && (
                    <div>
                        <div className="form-group">
                            <TextInput
                                name="patientFirstName"
                                label="Patients First Name"
                                labelClassName="control-label col-sm-4"
                                fieldClassName="col-sm-8 col-md-6"
                                value={patientFirstName}
                                maxLength={30}
                                onChange={onPatientFirstNameChange}
                                onBlur={() => {
                                    if (patientFirstName) {
                                        callUpdateFormData();
                                    }
                                }}
                                required={true}
                                error={errors.patientFirstName}
                                showError={true}
                            />
                        </div>
                        <div className="form-group">
                            <TextInput
                                name="patientLastName"
                                label="Patients Last Name"
                                labelClassName="control-label col-sm-4"
                                fieldClassName="col-sm-8 col-md-6"
                                value={patientLastName}
                                maxLength={30}
                                onChange={onPatientLastNameChange}
                                onBlur={() => {
                                    if (patientLastName) {
                                        callUpdateFormData();
                                    }
                                }}
                                required={true}
                                error={errors.patientLastName}
                                showError={true}
                            />
                        </div>
                        <div className="form-group">
                            <div className="form-horizontal" role="form">
                                <div
                                    className="col-sm-4"
                                    style={{
                                        padding: '6px 12px',
                                    }}
                                >
                                    <label
                                        className={
                                            !fitDate && validating
                                                ? 'control-label-wsr-has-error'
                                                : 'control-label-wsr'
                                        }
                                    >
                                        {intl.formatMessage({
                                            id: 'Date_Sold_Fit',
                                            defaultMessage: 'DATE SOLD / FIT',
                                        })}
                                        :{' '}
                                        {intl.formatMessage({
                                            id: 'HEARING_AIDS_ONLY',
                                            defaultMessage:
                                                '(HEARING AIDS ONLY)',
                                        })}
                                    </label>
                                </div>
                                <div
                                    className="col-sm-8"
                                    style={{
                                        padding: '6px 12px',
                                    }}
                                >
                                    <DatePicker
                                        className={
                                            !fitDate && validating
                                                ? 'col-sm-8 date-picker-wsr-has-error'
                                                : 'col-sm-8 date-picker-wsr'
                                        }
                                        selected={fitDate}
                                        selectsStart={true}
                                        name="fitDate"
                                        onChange={onFitDateChange}
                                        autoComplete="off"
                                        isClearable={false}
                                        showTimeSelect={false}
                                        required={false}
                                        popperPlacement="top-end"
                                        monthsShown={1}
                                    />
                                    <span
                                        className="input-group-addon"
                                        style={{
                                            display: 'inline-block',
                                            verticalAlign: 'top',
                                            height: '34px',
                                            backgroundColor:
                                                !fitDate && validating
                                                    ? '#f2dede'
                                                    : '#eee',
                                            borderColor:
                                                !fitDate && validating
                                                    ? '#a94442'
                                                    : '#ccc',
                                        }}
                                    >
                                        *
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <h3 className={isNuEar ? 'nuEar gutter-top' : 'starkey gutter-top'}>
                {intl.formatMessage({
                    id: 'Account_Information',
                    defaultMessage: 'Account Information',
                })}
            </h3>
            {userAccountData !== null && userAccountData !== undefined && (
                <div className="form-horizontal">
                    <div className="form-group">
                        <div>
                            <SelectInput
                                name="accountNumber"
                                label="Account Number"
                                labelClassName="ontrol-label col-sm-4"
                                fieldClassName="col-sm-8 col-md-6"
                                options={
                                    userAccountData.billToAccountsList &&
                                    userAccountData.billToAccountsList!.map(
                                        (st) => ({
                                            value: st.code,
                                            text: st.name,
                                        })
                                    )
                                }
                                value={billToAccount}
                                hasDefaultOption={false}
                                onChange={onBillToAccountChange}
                                required={false}
                            />
                        </div>
                    </div>

                    <div className="form-group">
                        <label className="control-label col-sm-4 hidden-xs">
                            {intl.formatMessage({
                                id: 'Address',
                                defaultMessage: 'Address',
                            })}
                            :
                        </label>
                        <p className="form-control-static col-sm-8 col-md-6">
                            <span>{userAccountData.billToPartyName}</span>
                            <br></br>
                            <span>{userAccountData.billToStreet1}</span>
                            <br></br>
                            <span>{userAccountData.billToCity}</span>,{' '}
                            <span>{userAccountData.billtoState}</span>{' '}
                            <span>{userAccountData.billToPostalCode}</span>
                        </p>
                    </div>

                    <div className="form-group">
                        <div>
                            <SelectInput
                                name="shipToAccount"
                                label="Ship To Account"
                                labelClassName="ontrol-label col-sm-4"
                                fieldClassName="col-sm-8 col-md-6"
                                options={
                                    userAccountData.shipToAccountsList &&
                                    userAccountData.shipToAccountsList.map(
                                        (st) => ({
                                            value: st.code,
                                            text: st.name,
                                        })
                                    )
                                }
                                value={shipToAccount}
                                hasDefaultOption={false}
                                onChange={onShipToAccountChange}
                                required={false}
                            />
                        </div>
                    </div>

                    <div className="form-group">
                        <label className="control-label col-sm-4 hidden-xs">
                            {intl.formatMessage({
                                id: 'Address',
                                defaultMessage: 'Address',
                            })}
                            :
                        </label>
                        <p className="form-control-static col-sm-8 col-md-6">
                            <span>{userAccountData.shipToPartyName}</span>
                            <br></br>
                            <span>{userAccountData.shipToStreet1}</span>
                            <br></br>
                            <span>{userAccountData.shipToCity}</span>,{' '}
                            <span>{userAccountData.shipToState}</span>{' '}
                            <span>{userAccountData.shipToPostalCode}</span>
                        </p>
                    </div>

                    <div className="form-group">
                        <TextInput
                            name="contactName"
                            label="Contact Name"
                            labelClassName="control-label col-sm-4"
                            fieldClassName="col-sm-8 col-md-6"
                            value={registerWarrantyInputData.contactName}
                            maxLength={25}
                            onChange={updateUserData}
                            onBlur={() => callUpdateFormData()}
                            required={true}
                            error={errors.contactName}
                            showError={true}
                        />
                    </div>

                    <div className="form-group">
                        <TextInput
                            name="phoneNumber"
                            label="Phone Number"
                            labelClassName="ontrol-label col-sm-4"
                            fieldClassName="col-sm-8 col-md-6"
                            value={registerWarrantyInputData.phoneNumber}
                            maxLength={20}
                            onChange={updateUserData}
                            onBlur={() => callUpdateFormData()}
                            required={true}
                            error={errors.phoneNumber}
                            showError={true}
                        />
                    </div>

                    <div className="form-group">
                        <TextInput
                            name="emailAddress"
                            label="Email Address"
                            labelClassName="ontrol-label col-sm-4"
                            fieldClassName="col-sm-8 col-md-6"
                            value={registerWarrantyInputData.emailAddress}
                            maxLength={30}
                            onChange={updateUserData}
                            onBlur={() => callUpdateFormData()}
                        />
                    </div>
                </div>
            )}
            {showFirstConsentModal && (
                <FirstConsentModal
                    onAccept={() => {
                        onAcceptFirstConsentModal();
                    }}
                    onClose={() => onCloseFirstConsentModal()}
                />
            )}
            {showSecondConsentModal && (
                <SecondConsentModal
                    onAccept={() => undefined}
                    onClose={onCloseSecondConsentModal}
                />
            )}
        </div>
    );
};

export default RegisterWarranty;
